import React from "react";
import CustomNavbar from "../components/CustomNavbar";
import FooterTwo from '../components/Footer/FooterTwo';
import FooterData from '../components/Footer/FooterData';
import FooterAmani from "../components/Footer/FooterAmani";
const NotFound = () => (
  <div className="body_wrapper">
       <CustomNavbar mClass="erp_menu" hbtnClass="er_btn" nClass="mr-auto" />
    <section className="error_two_area" style={{marginTop:"50px"}}>
      <div className="container flex">
        <div className="error_content_two text-center">
          <img src={require("../img/new/error.png")} alt="" />
          <h2>Error. We can’t find the page you’re looking for.</h2>
          <p>
            Sorry for the inconvenience. Go to our homepage or check out our
            latest collections...
          </p>
          <form action="#" className="search">
            <input type="text" className="form-control" placeholder="search" />
          </form>
          <a href="/" className="about_btn btn_hover">
            Back to Home Page <i className="arrow_right"></i>
          </a>
        </div>
      </div>
    </section>
    <FooterAmani/>
  </div>
);
export default NotFound;
